import { Action } from '@ngrx/store';

import { DisplayMode, SortInfo } from '@stylehaven/components';
import { Overview } from './view-options.entity';

export enum ViewOptionsActionTypes {
    SetSort = '[ViewState] Set Sort',
    SetDisplayMode = '[ViewState] Set DisplayMode',
    SetFiltersPanelState = '[ViewState] Set FiltersPanel state',
    SetRecordTreePanelState = '[ViewState] Set RecordTreePanel state'
}

export class SetDisplayMode implements Action {
    type: ViewOptionsActionTypes.SetDisplayMode = ViewOptionsActionTypes.SetDisplayMode;
    constructor(
        public view: Overview,
        public displayMode: DisplayMode
    ) {}
}

export class SetSortInfo implements Action {
    type: ViewOptionsActionTypes.SetSort = ViewOptionsActionTypes.SetSort;
    constructor(
        public view: Overview,
        public sort: SortInfo
    ) {}
}

export class SetFiltersPanelState implements Action {
    type: ViewOptionsActionTypes.SetFiltersPanelState = ViewOptionsActionTypes.SetFiltersPanelState;
    constructor(
        public view: Overview,
        public opened: boolean
    ) {}
}

export class SetRecordTreePanelState implements Action {
    type: ViewOptionsActionTypes.SetRecordTreePanelState = ViewOptionsActionTypes.SetRecordTreePanelState;
    constructor(
        public view: Overview,
        public opened: boolean
    ) {}
}

export type ViewOptionsAction = SetDisplayMode | SetSortInfo | SetFiltersPanelState | SetRecordTreePanelState;
